<template>
  <div class="form-section">
    <h2 class="form-section__title">{{@title}}</h2>
    {{yield}}
  </div>
</template>
